module.exports = __webpack_public_path__ + "07_long_gold.c3667534.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/07_long_gold.png
// module id = MAQr
// module chunks = 0